import api from '../source/api'

const user = {

    setUploadData(state) {
        localStorage.setItem('uploadData', JSON.stringify(state))
    },

    isGuest() {
        return JSON.parse(localStorage.getItem('user')) !== null ? false : true
    },

    setUser(data) {
        localStorage.setItem('user', JSON.stringify(data))
    },

    setUserData(name, data) {
        let user = this.getUser();
        user[name] = data;
        this.setUser(user);
    },

    getUser() {
        return  JSON.parse(localStorage.getItem('user'));
    },

    hasModule(code) {
        let userObj = JSON.parse(localStorage.getItem('user'));


        if (userObj) {
            if (userObj.enabledModules) {
                return userObj.enabledModules.includes(code);
            }

            if (userObj.moduleInfo) {
                return userObj.moduleInfo[code];
            }
        }
        return false;
    },

    showBalance() {
        let userObj = JSON.parse(localStorage.getItem('user'));
        return userObj && userObj.balanceInfo ? userObj.balanceInfo.showBalance : false;
    },

    isTestMode() {
        let userObj = JSON.parse(localStorage.getItem('user'));
        return userObj.balanceInfo.isTestMode;
    },

    testModeExpiration() {
        let userObj = JSON.parse(localStorage.getItem('user'));
        return userObj.balanceInfo.testModeExpiration;
    },
};

export default user


// WEBPACK FOOTER //
// ./src/helpers/user.js